import React from 'react';
import { useTranslation } from 'react-i18next';
import type { TaskWithPopulatedAssignees } from '@momentum/types';
import { GoalTaskRow } from './GoalTaskRow';
import { GoalTasksTableHeader } from './GoalTasksTableHeader';

interface GoalTasksTableProps {
  tasks: TaskWithPopulatedAssignees[];
  goalId: string;
  currentEmployeeId?: string;
}

export const GoalTasksTable: React.FC<GoalTasksTableProps> = ({
  tasks,
  currentEmployeeId,
}) => {
  const { t } = useTranslation('oneOnOne');

  if (tasks.length === 0) {
    return (
      <div className="rounded-lg border border-slate-200/60 bg-slate-50/80 p-4">
        <p className="text-sm text-muted-foreground italic text-center">
          {t('noTasksAssigned')}
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-slate-200/60 bg-slate-50/80 overflow-hidden">
      <GoalTasksTableHeader />

      <div className="divide-y divide-gray-100">
        {tasks.map((task) => (
          <GoalTaskRow
            key={task._id}
            task={task}
            currentEmployeeId={currentEmployeeId}
          />
        ))}
      </div>
    </div>
  );
};
